<template>
	<div>
		<base-nav
			v-model="showMenu"
			type="light"
			:transparent="true"
			menu-classes="justify-content-end"
			class="navbar-horizontal navbar-main login-header"
			expand="lg"
			align="center"
		>
			<template>
				<div class="navbar-collapse-header">
					<b-row>
						<b-col cols="6" class="collapse-brand">
							<!-- <router-link to="/" custom v-slot="{ navigate}">
                <a @keypress.enter="navigate" @click="navigate" role="link"><img src="/img/brand/white.png" ></a>
              </router-link> -->
						</b-col>
						<b-col cols="6" class="collapse-close">
							<button type="button" class="navbar-toggler" @click="toggleNavbar">
								<span></span>
								<span></span>
							</button>
						</b-col>
					</b-row>
				</div>

				<b-navbar-nav class="align-items-lg-center ml-lg-auto auth-header-style">
					<b-navbar-brand class="mt-3">
						<a href="http://dccllc.net">
							<img
								alt="DCC logo"
								height="60"
								src="/img/brand/dcc_company.png"
								style="height: 60px !important"
						/></a>
					</b-navbar-brand>
					<b-navbar-brand class="mt-3">
						<a href="http://www.dccllc.net/about-us/" class="h2"> About Us</a>
					</b-navbar-brand>

					<b-navbar-brand class="mt-3"
						><a href="http://www.dccllc.net/consultings/" class="h2"> Consulting</a>
					</b-navbar-brand>

					<b-navbar-brand class="mt-3"
						><a href="http://www.dccllc.net/products-services/" class="h2"> Products &amp; Services</a>
					</b-navbar-brand>

					<b-navbar-brand class="mt-3"
						><a href="http://www.dccllc.net/news/" class="h2"> News</a>
					</b-navbar-brand>
				</b-navbar-nav>
			</template>
		</base-nav>

		<div class="main-content">
			<div align="center" id="routerAlerts" style="position: absolute; top: 0%; right: 0%; z-index: 100"></div>
			<zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
				<router-view></router-view>
			</zoom-center-transition>
		</div>
		<Footer></Footer>
	</div>
</template>
<script>
import {BaseNav} from "@/components";
import {ZoomCenterTransition} from "vue2-transitions";
import {mapState} from "vuex";
//import * as THREE from "three";
import initService from "../../common/api-services/init-service";
import Footer from "./Footer.vue";
import ThemeSwitcher from "@/views/Components/Theme-Switcher.vue";

export default {
	components: {
		BaseNav,
		ThemeSwitcher,
		ZoomCenterTransition,
		Footer,
	},
	props: {
		backgroundColor: {
			type: String,
			default: "black",
		},
	},
	data() {
		return {
			showMenu: false,
			menuTransitionDuration: 250,
			pageTransitionDuration: 200,
			pageClass: "login-page",
			page: null,
			cube: null,
			renderer: null,
			scene: [],
			camera: null,
			container: null,
			SEPARATION: 40,
			AMOUNTX: 130,
			AMOUNTY: 35,
			particles: undefined,
			particle: null,
			count: 0,
			windowHalfX: null,
			windowHalfY: null,
			animationId: -1,
		};
	},
	computed: {
		...mapState({
			errors: state => state.auth.errors,
		}),

		title() {
			return `${this.$route.name} Page`;
		},

		apiVersion() {
			return initService.getApiVersion();
		},
	},
	methods: {
		renderBackground() {
			this.windowHalfX = window.innerWidth / 2;
			this.windowHalfY = window.innerHeight / 2;
			this.init();
			this.animate();
		},

		toggleNavbar() {
			// document.body.classList.toggle("nav-open");
			this.showMenu = !this.showMenu;
		},
		closeMenu() {
			document.body.classList.remove("nav-open");
			this.showMenu = false;
		},
		setBackgroundColor() {
			document.body.classList.add("bg-login-gradient");
		},
		removeBackgroundColor() {
			document.body.classList.remove("bg-login-gradient");
		},
		updateBackground() {
			if (!this.$route.meta.noBodyBackground) {
				this.setBackgroundColor();
			} else {
				this.removeBackgroundColor();
			}
		},

		init() {
			/*
			//https://stackoverflow.com/questions/16177056/changing-three-js-background-to-transparent-or-other-color

			// this.container = document.createElement('div');
			// document.body.appendChild(this.container);
			//LoginPage
			// this.page = document.getElementById('LoginPage');
			// this.page.appendChild(this.container);
			this.container = document.getElementById("Waves");
			if (this.container) {
				this.container.className += this.container.className ? " waves" : "waves";
				//this.container.className='bg-login-gradient waves';
			}
			this.scene = new THREE.Scene();
			this.camera = new THREE.PerspectiveCamera(120, window.innerWidth / window.innerHeight, 1, 10000);
			this.camera.position.y = 150;
			this.camera.position.z = 300;
			this.camera.rotation.x = 0.35;
			this.particles = new Array();

			let material = new THREE.SpriteMaterial({
				color: 0x359ba7,
				opacity: 0.33,
			});

			let i = 0;
			for (let ix = 0; ix < this.AMOUNTX; ix++) {
				for (let iy = 0; iy < this.AMOUNTY; iy++) {
					this.particle = this.particles[i++] = new THREE.Sprite(material);
					this.particle.position.x = ix * this.SEPARATION - (this.AMOUNTX * this.SEPARATION) / 2;
					this.particle.position.z = iy * this.SEPARATION - (this.AMOUNTY * this.SEPARATION - 10);
					this.scene.add(this.particle);
				}
			}
			this.renderer = new THREE.WebGLRenderer({alpha: true});
			this.renderer.setSize(window.innerWidth, window.innerHeight);

			//set the color of the background.
			this.renderer.setClearColor(0xffffff, 0);

			this.container.appendChild(this.renderer.domElement);
			window.addEventListener("resize", this.onWindowResize(), false);
		 */
		},

		onWindowResize() {
			// this.windowHalfX = window.innerWidth / 2;
			// this.windowHalfY = window.innerHeight / 2;
			// this.camera.aspect = window.innerWidth / window.innerHeight;
			// this.camera.updateProjectionMatrix();
			// this.renderer.setSize(window.innerWidth, window.innerHeight);
		},

		animate() {
			// this.animationId = requestAnimationFrame(this.animate);
			// this.render();
			//
			// //stop animation after 2 minutes.
			// setTimeout(() => {
			// 	this.stopAnimation();
			// }, 120000);
		},

		//we need to run this method when a user clicks login or leaves the page.  Please implement.
		stopAnimation() {
			//console.log('stopping animation...');
			//cancelAnimationFrame(this.animationId);
		},

		render() {
			// let i = 0;
			// for (let ix = 0; ix < this.AMOUNTX; ix++) {
			// 	for (let iy = 0; iy < this.AMOUNTY; iy++) {
			// 		this.particle = this.particles[i++];
			// 		this.particle.position.y =
			// 			Math.sin((ix + this.count) * 0.5) * 20 + Math.sin((iy + this.count) * 0.5) * 20;
			// 		this.particle.scale.x = this.particle.scale.y =
			// 			(Math.sin((ix + this.count) * 0.3) + 2) * 4 + (Math.sin((iy + this.count) * 0.5) + 1) * 4;
			// 	}
			// }
			// this.renderer.render(this.scene, this.camera);
			// this.count += 0.2;
		},
	},
	mounted() {
		this.renderBackground();
		this.$root.$on("renderBackground", res => {
			if (res) {
				this.renderBackground();
			}
		});
		this.$root.$on("stopBackgroundAnimation", res => {
			//if (res) {
			this.stopAnimation();
			//}
		});
	},

	beforeDestroy() {
		this.removeBackgroundColor();
	},

	beforeRouteUpdate(to, from, next) {
		// Close the mobile menu first then transition to next page
		if (this.showMenu) {
			this.closeMenu();
			setTimeout(() => {
				next();
			}, this.menuTransitionDuration);
		} else {
			next();
		}
	},

	watch: {
		$route: {
			immediate: true,
			handler: function () {
				this.updateBackground();
			},
		},
	},
};
</script>
